(function() {

    'use strict';


    /**
     * Flash implementation for the VideoAbstract solution
     */

    var Feat = SAPO.Project.Video.Features,
        SWF  = SAPO.Utility.SWF;

    // early exit
    if (!Feat.hasFlash) { return; }



    /**
     * VIDEO ELEMENT ABSTRACTION USING FLASH
     *
     * @since April 2013 - November 2013
     * @author jose.p.dias AT co.sapo.pt
     *
     * We're trying to mimic the VideoJS interface and events using Adobe Flash and VideoJS's SWF.
     * https://github.com/videojs/video-js-swf
     *
     * Minor patches applied in our fork:
     * https://github.com/JosePedroDias/video-js-swf
     */



    var DELTAT = Math.round( 0.25 * 1000 ); // used for currentTime emulation events
    var STREAM_TIMEOUT = 5; // after 5 seconds without timeUpdate, flash live videos (rtmp) throw a NO_STREAM error
    var SKIP_LIVE_TIMEOUT_DETECTION = 1;



    var instances = {};

    // Flash <-> JS bridge
    var router = function(method) {
        //console.log('ROUTER: ' + method);
        return function(id) {
            //console.log('router called id=%s method=%s', id, method);
            var inst = instances[id];

            /*var argsL = arguments.length;
            var args = new Array(argsL); // optimizable arguments-to-array
            for(var i = 0; i < argsL; ++i) {
                args[i] = arguments[i];
            }
            console.log(this, args);*/

            inst['_on' + method].apply(inst, arguments);
        };//.bindObj(method);
    };

    window.svFlashReady = router('Ready');
    window.svFlashEvent = router('Event');
    window.svFlashError = router('Error');



    // video abstraction (uri is optional)
    var VideoFlashImpl = function VideoFlashImpl(o) {
        // console.log('vfi opts: ', o);

        this._handlers = {};


        /*window.top.f = this;
        window.LOG = function() { console.log(arguments); }
        window.lf = function() { return window.LOG; }
        f._el.vjs_setProperty("errorEventProxyFunction", "LOG");
        */

        this._id = 'svFl' + ~~( Math.random() * 10000 );

        instances[ this._id ] = this;

        if (!o) {
            o = {};
        }

        if (!('container' in o)) {
            o.container = document.body;
        }

        this._options = o;



        var flashvars = {
             readyFunction:           'svFlashReady'
            ,eventProxyFunction:      'svFlashEvent'
            ,errorEventProxyFunction: 'svFlashError'
            ,preload:                 o.prefetch
        };

        if (o.poster) {
            flashvars.poster = o.poster;
        }

        if (o.src) {
            this._tmp = o.src;
        }

        //console.log(flashvars);

        this._el = SWF.embed({
            swf:       '//' + SV_DOMAIN + ( window.location.port ? ( ':' + window.location.port ) : '' ) + '/Projects/Video/' + SV_VERSION + '/flash/videojs.swf',
            dims:      o.dimensions,
            id:        this._id,
            container: o.container,
            params: {
                allowfullscreen:   true,        // if trueish, allowfullscreen param is set to true
                allowscriptaccess: 'always',    // allowscriptaccess param
                wmode:             'opaque',    // wmode param: opaque | transparent | window
                //bgcolor:           '#FF0000', // bgcolor param
                //quality:           'high'     // quality param
            },
            flashvars: flashvars,
            insteadOf: !!o.insteadOf
        });

        this._el.style.zIndex = 10000; // promote flash while not ready to let user click on flash blocker
        this._el.className = 'video fill';
        this._el.setAttribute('tabindex', -1);

        // Kill this with fire if there are no regressions. 280714
        /*
        var _this = this;
            //console.log('FLASHVIDEO ONREADY');
        if(SAPO.Browser.IE && parseInt(SAPO.Browser.version, 10) < 9){
            setTimeout(function() { // this is important so ready event gets fired upwards
                if (_this._options && _this._options.onReady) {
                    _this._options.onReady(_this);
                }
            }, 0);
        }
        */
    };

    VideoFlashImpl.prototype = {
        // EVENTS

        addEventListener: function(evType, cb) {
            var bag = this._handlers[evType];
            if (!bag) {
                this._handlers[evType] = [cb];
            }
            else {
                bag.push(cb);
            }
        },

        removeEventListener: function(evType, cb) {
            var bag = this._handlers[evType];
            if (!bag) { return; }
            for (var i = 0, f = bag.length; i < f; ++i) {
                if (bag[i] === cb) {
                    bag.splice(i, 1);
                    --i;
                    --f;
                }
            }
        },

        fire: function(evType, val) {
            //console.log('FIRE', evType, val);
            this._onEvent(this._id, evType, val);
        },



        // LOAD AND PLAY STATE

        canAutoplay: function() {
            return true;
        },

        unload: function() {
            this._el.vjs_setProperty('src', '');
        },

        load: function(src, type, startPlaying) {
            delete this._isLivePaused;

            if (src === this._src) {
                return; // HACK
            }

            var wasPlaying = this.isPlaying();
            if (wasPlaying) {
                this.pause();
            }

            //console.log('LOAD REQUESTED FOR ' + src);
            this._noVideoYet = true;

            if (this._options.prefetch) {
                startPlaying = true;
            }

            //console.log('LOAD', src, this._tmp, type, startPlaying);

            delete this._loadedMetadata; // fixing videojs ugly bugs
            delete this._lastDuration;

            this._parseURI(src);

            /*if (this._timerI) {
                this._resetTimer();
            }*/
            this._setupTimer();

            if (!this._id) {
                this._tmp = src;
                //console.log('ignoring load request for now', uri);
                return;
            }

            if ( (/\.mp3$/).test(this._src) ) {
                this._el.vjs_setProperty('mode', 'audio');
            }
            else {
                this._el.vjs_setProperty('mode', 'video');
            }

            if (this._isLive) {
                this._el.vjs_setProperty('rtmpConnection', this._rtmpConnection);
                this._el.vjs_setProperty('rtmpStream',     this._rtmpStream);
            }
            else {
                this._el.vjs_setProperty('src', this._src);
            }

            this._el.vjs_load();

            if (startPlaying) { // this autoplay sucks
                this.play();
            }
        },

        isPlaying: function() {
            return (this._el.vjs_getProperty('currentTime') > 0 &&
                    !this._el.vjs_getProperty('paused') &&
                    !this._ended
                    //!this._el.vjs_getProperty('ended')
            );
        },

        play: function() {
            /*if(!this._src && !this._rtmpStream) {
                this.fire('play');
                return;
            }*/
            if (this._ended) { // fixing ended
                this._ended = false;
                this._el.vjs_setProperty('currentTime', 0);
                this._el.vjs_play();
                this.fire('play');
                return;
            }

            if (this._isLivePaused) { // VIDEOJS vjs_play does not work well in RTMP...
                delete this._isLivePaused;
                this._el.vjs_load();
                this._el.vjs_play(); // dangerous, potential to explode
            }
            else {
                this._el.vjs_play();
            }
        },

        pause: function() {
            this._el.vjs_pause();
            if (this._isLive) {
                this._isLivePaused = true;
            }
        },



        // TIME-RELATED

        getCurrentTime: function() {
            return this._el.vjs_getProperty('currentTime');
        },

        setCurrentTime: function(t) {
            /*var d = this.getDuration();
            console.log("setting to ", t, d);

            if (t > d) {
                t = d - 0.5;
            }*/

            try {
                this._el.vjs_setProperty('currentTime', t);
                this.fire('timeupdate');
            } catch (ex) {}
        },

        getDuration: function() {
            if (this._isLive || !this._id) {
                return undefined;
            }

            return this._el.vjs_getProperty('duration');
        },

        getCache: function(asRatio) {
            var d, l = 1;

            d = this._el.vjs_getProperty('duration');

            if (d > 0) {
                var b = this._el.vjs_getProperty('buffered');

                if (asRatio) {
                    b /= d;
                }
                else {
                    l = d;
                }

                //console.log('end', b, 'length', l);
                return {start:0, end:b, length:b};
            }

            return {start:0, end:1, length:1};
        },

        isLive: function() {
            return !!this._isLive;
        },

        isReady: function() {
            return !!this._isReady;
        },



        // VOLUME-RELATED

        getVolume: function() {
            return this._el.vjs_getProperty('volume');
        },

        setVolume: function(v) {
            try{
                this._el.vjs_setProperty('volume', v);
            } catch(e){}
        },



        // SIZE

        getVideoSize: function() {
            return [
                this._el.vjs_getProperty('videoWidth'),
                this._el.vjs_getProperty('videoHeight')
            ];
        },



        // DOM

        getElement: function() {
            return this._el;
        },

        kill: function() {
            this._resetTimer();

            this._el.parentNode.removeChild(this._el);
        },



        // INTERNALS

        _parseURI: function(uri) {
            this._isLive = (uri.substring(0, 4) === 'rtmp');

            if (this._isLive) {
                var lastSlash = uri.lastIndexOf('/');
                this._rtmpConnection = uri.substring(0, lastSlash);
                this._rtmpStream     = uri.substring(lastSlash + 1);
            }
            else {
                this._src = uri;
            }
        },

        _onReady: function(/*id*/) {
            this._isReady = true;
            this._el.style.zIndex = '';

            if (this._options.onReady) { // call parent's onReady only once
                this._options.onReady(this);
                delete this._options.onReady;
            }

            this.fire('impl_ready', 'flash');
            this.fire('error', '');
            if (this._tmp) { // allow loading more than once - chrome apparently calls this function twice and isn't really ready for loading at the first time
                this.load(this._tmp, '', !!this._options.prefetch);
                delete this._tmp;
            }
        },

        _onEvent: function(id, evType, val) {
            /*jshint maxcomplexity:20 */
            var v;

            //console.log('onEvent: ', evType, JSON.stringify(val));

            // fixing videojs...
            if (evType === 'stageclick') {
                evType = 'click';
            }
            else if (evType === 'durationchange') {
                v = this.getDuration();
                if (v === this._lastDuration) { return; }
                this._lastDuration = v;
            }
            else if (evType === 'loadedmetadata') {
                if (this._loadedMetadata) { return; }
                this._loadedMetadata = true;
            }
            else if (evType === 'ended') {
                try {
                    this._el.vjs_pause();
                } catch(ex) {

                }
                this._ended = true;
                this.fire('pause');
            }
            else if (evType === 'timeupdate') {
                this._ended = false;
            }

            var bag = this._handlers[evType];
            //console.log( [evType, this._timerI, bag].join(' | ') );
            if (evType === 'play' && !this._timerI) {
                delete this._noVideoYet;
                this._setupTimer();
            }
            else if (this._timerI && (evType === 'pause' || evType === 'ended')) {
                this._resetTimer();
            }

            var ev = {
                target:     this._el,
                srcElement: this._el,
                type:       evType
            };

            if (val !== undefined) {
                ev.value = val;
            }

            //var bag = this._handlers[evType];
            if (!bag) {
                return; // onsrcchange
            }

            for (var i = 0, f = bag.length; i < f; ++i) {
                bag[i](ev);
            }
        },

        _onError: function(id, error) {
            //console.log('onError', error);

            if (error === 'srcnotfound') {
                // Ignore the initial 'srcnotfound' error if there's no source
                if(!this._src) {
                    return;
                }
                return  this.fire('error', 'FLASH_SOURCE_NOT_FOUND');
            }

            this.fire('error', 'FLASH_GENERAL_ERROR');
        },

        _setupTimer: function() {
            if (this._timerI) {
                this._resetTimer();
            }

            //console.log('STARTING TIMER');
            var cb = this._isLive ? this._onTimerLive : this._onTimer;
            this._timerI = setInterval(cb.bindObj(this), DELTAT);
            cb.apply(this); // call it NOW
        },

        _resetTimer: function() {
            clearInterval(this._timerI);
            delete this._timerI;
            delete this._liveStartT;
            delete this._prevState;
        },

        _onTimer: function() {
            var t = this.getCurrentTime();
            var c = JSON.stringify( this.getCache() );

            if (t !== this._lastT) {
                this.fire('timeupdate');
                this._lastT = t;
            }

            if (c !== this._lastC) {
                this._lastC = c;
                this.fire('progress');
            }
        },

        _onTimerLive: function() {
            var t = new Date().valueOf() / 1000;

            if (!this._liveStartT) {
                // console.log('LIVE TIMER STARTED COUNTING...');
                this._liveStartT = t;
                this._prevCT = this.getCurrentTime();

                this.fire('timeupdate');
                this._lastT = 0;
            }

            var ct     = this.getCurrentTime();
            var dt     = t - this._liveStartT;
            var sameCT = (ct === this._prevCT);

            // console.log('dt:', dt.toFixed(1), 'ct:', ct.toFixed(1));
            if (sameCT && dt > STREAM_TIMEOUT) {
                // console.log('NO STREAM?', sameCT ? 'SAME' : 'DIFF', dt.toFixed(1));
                if (this._prevState !== 'ERR') {
                    // console.log('OK -> ERR');
                    this.fire('error', 'NO_STREAM');
                    this._prevState = 'ERR';
                }
            }
            else if (sameCT) {
            }
            else {
                 if (this._prevState !== 'OK') {
                    // console.log('ERR -> OK');
                    this.fire('error', '');
                    this._prevState = 'OK';
                }
                // console.log('OK!       ', sameCT ? 'SAME' : 'DIFF', dt.toFixed(1));
                this._liveStartT = t;
                this._prevCT = ct;
            }

            if (dt !== this._lastT) {
                this.fire('timeupdate');
                this._lastT = dt;
            }
        }
    };

    if (SKIP_LIVE_TIMEOUT_DETECTION) {
        VideoFlashImpl.prototype._onTimerLive = VideoFlashImpl.prototype._onTimer;
    }



    // this method is static and regular
    VideoFlashImpl.canMimeTypeBePlayed = VideoFlashImpl.prototype.canMimeTypeBePlayed = function(mimeType) {
        switch (mimeType) {
            case 'video/mp4':
            case 'video/flv':
            case 'video/x-flv':
            case 'rtmp/flv':
            case 'rtmp/mp4':
            case 'audio/mp3':
                return true;

            default:
                return false;
        }
    };



    SAPO.namespace('Project.Video.Controllers');
    SAPO.Project.Video.Controllers.VideoFlashImpl = VideoFlashImpl;

    SAPO.Project.Video.Controllers.videoImpls['flash'] = VideoFlashImpl;

})();
